import React, {FormEvent, useCallback, useState} from 'react';
import {API} from '../../modules/api';
import store from '../../modules/session';
import {runInAction} from 'mobx';
import {toast} from 'react-toastify';
import {useNavigate} from 'react-router-dom';
import {observer} from 'mobx-react';
import {useTranslation} from "react-i18next";
import {Checkbox, Input, InputPassword} from "../../components/FormControls";
import AuthWrap from "./AuthWrap";
import {EFieldGroup, EService, EUserRole} from '../../modules/rest';
import Button from "../../components/Button";

const LoginRoute = observer(() => {
  const {t} = useTranslation();
  const [email, setEmail] = useState(localStorage.getItem('email') ?? '');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [agree, setAgree] = useState<boolean>(false);
  const navigate = useNavigate();

  const submit = useCallback(
    (e: FormEvent) => {
      e.preventDefault();
      setLoading(true);
      API.Users.login({email, password, role: EUserRole.Youtuber, service: EService.Tubyx}, [EFieldGroup.UserBalance])
        .then((res) => {
          window.localStorage.setItem('token', res.token);
          window.localStorage.setItem('email', email);
          API.setToken(res.token);
          runInAction(() => (store.user = res.user));
          const returnPath = window.localStorage.getItem('return') ?? '/';
          window.localStorage.removeItem('return');
          navigate(returnPath, {replace: true});
        })
        .catch(toast.error)
        .finally(() => setLoading(false));
    },
    [email, password, setLoading, navigate]
  );

  return (
    <AuthWrap loading={loading} onSubmit={submit}>
      <Input
        className="mb-4"
        label={'EMAIL'}
        placeholder={t('EMAIL_PLACEHOLDER') || ''}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        autoFocus
        type="email"
        required
      />
      <InputPassword
        className="mb-4"
        onForgotPassword={() => navigate('/password')}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />
      {/*<Checkbox*/}
      {/*  className='mb-4'*/}
      {/*  checked={remember}*/}
      {/*  onChange={(e) => setRemember(e.target.checked)}*/}
      {/*  label={'REMEMBER_ME'}*/}
      {/*/>*/}
      <div className="text-muted mb-4 pb-3 d-flex align-items-start">
        <Checkbox
          // className={'ps-4'}
          checked={agree}
          onChange={(e) => setAgree(e.target.checked)}
          id='agree'
        />
        <label className="form-check-label cursor-pointer" htmlFor="agree">
          {t('TERMS_TEXT_1')}{' '}
          <span
            className="text-muted"
          >
            {t('TERMS_TEXT_2')}
          </span>{' '}
          {t('TERMS_TEXT_3')}{' '}
          <span
            className="text-muted"
          >
            {t('TERMS_TEXT_4')}
          </span>
        </label>
        {/*<label className="form-check-label cursor-pointer" htmlFor="agree">*/}
        {/*  {t('TERMS_TEXT_1')}{' '}*/}
        {/*  <a*/}
        {/*    href="https://docs.google.com/document/d/1p0H79kYZNFwDA3bPT5K-9IS8MsVi__QfRkuMqs676Cg/edit"*/}
        {/*    target="_blank"*/}
        {/*    rel="noreferrer"*/}
        {/*    className="text-muted"*/}
        {/*  >*/}
        {/*    {t('TERMS_TEXT_2')}*/}
        {/*  </a>{' '}*/}
        {/*  {t('TERMS_TEXT_3')}{' '}*/}
        {/*  <a*/}
        {/*    href="https://docs.google.com/document/d/1OcaEyy8iude04mD87ns6wGEpUZU8WZXSlNjW8b1HzJs/edit"*/}
        {/*    target="_blank"*/}
        {/*    rel="noreferrer"*/}
        {/*    className="text-muted"*/}
        {/*  >*/}
        {/*    {t('TERMS_TEXT_4')}*/}
        {/*  </a>*/}
        {/*</label>*/}
      </div>
      <Button
        loading={loading}
        disabled={!agree}
        type="submit"
        text='LOGIN'
        className='w-100'
      />
    </AuthWrap>
  );
});

export default LoginRoute;
